<template>
<modal
	class="integration-modal"
	size="medium"
	@close="closeModal"
>
	<template slot="header">
		<h3>{{ title }}</h3>
	</template>
	<template slot="body">
		<!-- Large Loader -->
		<div class="wrapper-loader">
			<loader :align="'center'"/>
			<div class="ml-3 text-center">
				{{ textLoader }}
			</div>
		</div>
	</template>
	<template slot="footer">
		<button
			id="btn-close"
			type="button"
			class="btn btn-default"
			@click="closeModal"
		>
			{{ $t('Cancel') }}
		</button>
	</template>
</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import Loader from '@/components/Loader.vue';
import {
	integrateShopee,
} from '@/api/marketplace-shopee';

export default {
	name: 'MarketplaceAddStoreForm',
	components: {
		Modal,
		Loader,
	},
	data() {
		return {
			isLoader: true,
			textLoader: this.$t('Please Wait For Your Account We Are Connecting'),
			title: this.$t('Integrating Shopee Store'),
		};
	},
	mounted() {
		this.integrateShopShopee();
	},
	methods: {
		integrateShopShopee() {
			const storeLabel = this.$route.query.store_label;
			const code = this.$route.query.code;
			const shopId = this.$route.query.shop_id;

			let valid = true;
			if (storeLabel === '' && code === '' && shopId === '') {
				valid = false;
			}

			const callback = (response) => {
				if (response.data) {
					this.$notify({
						group: 'app',
						type: 'success',
						title: this.$t('Omnichannel Shopee'),
						text: this.$t('Your account has been successfully linked'),
					});
					this.closeModal();
				}
			};
			const errorCallback = (e) => {
				if (e.response) {
					const response = e.response.data;
					const errorMessage = response.message;
					this.$notify({
						group: 'app',
						title: 'Omnichannel Shopee',
						type: 'error',
						text: errorMessage,
					});
					this.closeModal();
				}
			};
			if (valid) {
				const params = {
					storeLabel,
					code,
					shopId,
				};
				integrateShopee(params, callback, errorCallback);
			}
		},
		closeModal() {
			this.$emit('close');
			this.$router.replace({ query: {} });
		},
	},
};
</script>
